import { Button, Stack } from "@mui/material";
import { useHasSubjectRevokedCredentialsQuery } from "src/graphql/generated/api/graphql";
import { useTranslation } from "react-i18next";

interface RevokedIndicatorButtonProps {
    subjectDidId: number;
    onClick?: () => void;
}

export const RevokedIndicatorButton = ({
    subjectDidId,
    onClick,
}: RevokedIndicatorButtonProps) => {
    const { t } = useTranslation("common", {
        keyPrefix: "validated-questions",
    });

    const { data, loading } = useHasSubjectRevokedCredentialsQuery({
        variables: { subjectId: subjectDidId.toString() },
        skip: !subjectDidId,
    });

    if (loading) return null;

    if (!data?.hasSubjectRevokedCredentials) return null;

    return (
        <Stack sx={{ py: 2 }}>
            <Button onClick={onClick}>{t("show-revoked")}</Button>
        </Stack>
    );
};
